import React from "react";
import { Outlet } from "react-router-dom";


export const DongalBase : React.FC = () => {

    return (
        <Outlet />
    )
}